export default __webpack_public_path__ + "tmp_src/components/FeaturedVideo/FeaturedVideo~aurora.css.liquid";